export enum EPATHS{
    HOME="/",
    MARKETPLACE="/matketplace",
    MAPS="/maps",
    MAP="/map",
    TILE_MAP="/tile-map",
    TILE_MAP_V2="/tile-map-v2",
    LAND="/land",
    EXPLORE="/explore",
    /* Globe 3D d'activité mondiale (page publique, TRACK-2026-07-03-activity-globe-3d) */
    ACTIVITY="/activity",
    AUTHORS="/authors",
    AUTHOR="/author/:id",
    WALLET="/wallet",
    MY_PROFILE="/myProfile",
    PROFILE="/profile/:id",
    EDIT_PROFILE="/editProfile",
    GAIN="/gain",
    COUPON="/coupon",
    COUPON_DETAIL="/coupon/:id",
    CREATE_OPTIONS="/createOptions",
    CREATE_MULTIPLE="/createMultiple",
    USDC_AVAX="/usdc-avax",
    PROFILE_MANAGEMENT="/profilesManagement",
    CREATE_PROFILE="/createProfile",
    LOGIN="/login",
    ASSET_DETAIL="/3D_Asset/:nftId",
    LAND_DETAIL="/land/:landId",
    LAND_DETAIL_EPIC="/land_epic/:landId",
    LAND_GROUP_DETAIL="/land-group/:landGroupId",
    NFT_DETAIL="/3D_Collectible/:nftId/:itemId?",
    NFT_DETAIL_LEGACY="/3D_NFT/:nftId/:itemId?",
    EDIT_ITEM="/3D_Asset/edit/:nftId",
    /* Lot B2 — édition d'un EXEMPLAIRE par son propriétaire. Le segment `edit` littéral
       doit être matché AVANT NFT_DETAIL (/3D_Collectible/:nftId/:itemId?) dans la
       table de routage, sinon `edit` serait capturé comme :nftId. */
    EDIT_COLLECTIBLE="/3D_Collectible/edit/:nftId",
    SETTINGS="/setting",
    MY_COLLECTIONS='/collection',
    MY_BIDS='/bids',
    MY_COLLECTION_DETAIL="/collection/:assetId",
    MY_COLLECTION_HISTORY='/collection/:assetId/history',
    MY_NFTS='/my-collectibles',
    MY_NFTS_LEGACY='/myNfts',
    MY_NFTS_LEGACY2='/myCollectibles',
    GET_STARTED='/getstarted',
    NOTIFICATIONS='/notifications',
    TRANSACTIONS='/transactions',
    ADMIN_ACTION='/admin-action',
    RESET_PASSWORD='/reset-password',
    CONFIRM_PASSWORD='/confirm-password',
    CHANGE_EMAIL='/change-verification',
    EPIC_SSO='/epic-sso',
    BUY_FROM_EPIC="/buy-from-epic",
    /* Support desk (Phase 1 — SPEC-2026-06-10-support-desk.v2) */
    SUPPORT='/support',
    SUPPORT_PORTAL='/support/portal',
    SUPPORT_BUG_REPORT='/support/bug-report',
    SUPPORT_EARN='/support/earn',
    SUPPORT_DETAIL='/support/:id',
    SUPPORT_AGENT='/support/agent',
    SUPPORT_AGENT_DETAIL='/support/agent/:id',
    SUPPORT_FEATURES='/support/feature-requests',
    SUPPORT_FEATURES_NEW='/support/feature-requests/new',
    SUPPORT_FEATURES_DETAIL='/support/feature-requests/:id',
    /* Support v3 — badge SSO support.earniverse.io → marketplace (SPEC v3 §4) */
    AUTH_HANDOFF='/auth/handoff',
    /* Support v3 — relais SSO marketplace → support.earniverse.io (auto-login si déjà connecté) */
    SSO_RELAY='/auth/sso-relay',
    MARKET_STATS='/market-stats',
    ANALYTICS_DASHBOARD='/admin/analytics', /* SPEC-2026-07-03 product analytics dashboard */
    API_DOCS='/api-docs',
    CART='/cart',
    PORTFOLIO='/portfolio',
    WATCHLIST='/watchlist',
    AUTHOR_COLLECTIONS='/author-collections',
    AUTHOR_COLLECTION_DETAIL='/author-collections/:slug',
    /* Subscription mensuel (SPEC-2026-06-14-subscription-monthly.v3) */
    SUBSCRIPTION='/account/subscription',
    /* Earnicoins packs purchase page */
    EARNICOINS_PACKS='/earnicoins',
}